import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/clinic/Navbar";
import { Hero } from "@/components/clinic/Hero";
import { InfoStrip } from "@/components/clinic/InfoStrip";
import { About } from "@/components/clinic/About";
import { Services } from "@/components/clinic/Services";
import { FeaturedCare } from "@/components/clinic/FeaturedCare";
import { WhyChooseUs } from "@/components/clinic/WhyChooseUs";
import { Process } from "@/components/clinic/Process";
import { Team } from "@/components/clinic/Team";
import { Reviews } from "@/components/clinic/Reviews";
import { Appointment } from "@/components/clinic/Appointment";
import { WhatsAppCTA } from "@/components/clinic/WhatsAppCTA";
import { Contact } from "@/components/clinic/Contact";
import { FAQ } from "@/components/clinic/FAQ";
import { FinalCTA } from "@/components/clinic/FinalCTA";
import { Footer } from "@/components/clinic/Footer";

export default function App() {
    return (
        <div className="min-h-screen bg-white text-slate-900 antialiased">
            <Navbar />
            <main>
                <Hero />
                <InfoStrip />
                <About />
                <Services />
                <FeaturedCare />
                <WhyChooseUs />
                <Process />
                <Team />
                <Reviews />
                <Appointment />
                <WhatsAppCTA />
                <Contact />
                <FAQ />
                <FinalCTA />
            </main>
            <Footer />
            <Toaster position="top-center" richColors />
        </div>
    );
}
